<template>
  <span :style="badgeStyles">
    <slot></slot>
    <span :class="badgeClasses"
          :style="backgroundColorStyle"
    >
      <slot name="label">{{ label }}</slot>
    </span>
  </span>
</template>
<script>
import { PREFIX_CLASS } from '../../utils/constants'

const PREFIX_BADGE_CLASS = `${PREFIX_CLASS}badge`
const COLORS = ['success',
  'danger',
  'dark',
  'warning',
  'muted',
  'info']

export default {
  name: 'TBadge',
  props: {
    count: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 99
    },
    color: {
      type: String,
      default: 'danger'
    },
    dot: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    backgroundColorStyle() {
      if (COLORS.includes(this.color) === false) {
        return `background-color:${this.color}`
      }
      return ''
    },
    badgeStyles() {
      return this.$slots.default || this.dot ? 'position:relative;display:inline-block' : ''
    },
    badgeClasses() {
      let mainColor = COLORS.includes(this.color)
      return [
        `${PREFIX_BADGE_CLASS}`,
        {
          [`${PREFIX_BADGE_CLASS}--${this.color}`]: mainColor,
          [`${PREFIX_BADGE_CLASS}--top`]: this.$slots.default && !this.dot,
          [`${PREFIX_BADGE_CLASS}--dot`]: this.dot
        }
      ]
    },
    label() {
      if (this.dot) {
        return ''
      } else {
        let c = this.count
        let suffix = ''
        if (c > this.max) {
          c = this.max
          suffix = '+'
        }
        return `${c}${suffix}`
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/badge/badge.vue